import Banner from '../components/Banner'

const Dashboard = () => {
    return (
        <>
            <Banner />
        </>
    )
}

export default Dashboard
